<div>
    <sag-ui-button [menuOffsetTop]="12" sag-ui-menu-trigger [menuTriggerFor]="label" color="tertiary"
        ><span class="flex items-center gap-2">{{ label }}<span class="icon-chevron-down"></span></span>
    </sag-ui-button>

    <sag-ui-menu [menu]="label" class="max-h-72">
        <div class="bg-shs-gray-5 p-2 w-72 top-0">
            <sag-ui-input [formControl]="searchControl" [floatLabel]="true" label="Search Country"></sag-ui-input>
        </div>
        <div class="overflow-auto max-h-52 h-full flex flex-col gap-2 w-72">
            @for (value of countries | keyvalue; track $index) { @if
            (value.key.toLowerCase().includes(searchControl.value!.toLowerCase()) ||
            value.value.toLowerCase().includes(searchControl.value!.toLowerCase())) {
            <sag-ui-menu-item (click)="select(value.key)" (keydown.enter)="select(value.key)" tabindex="0"
                ><span
                    [attr.data-selected]="selected.includes(value.key)"
                    class="text-shs-white-1 data-[selected=true]:text-shs-orange"
                    >{{ value.key }}: {{ value.value }}</span
                ></sag-ui-menu-item
            >
            } }
        </div>
    </sag-ui-menu>
</div>
